
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch
	} from 'vue-property-decorator';
	import Util from '@/lib/util';
	import AbpBase from '@/lib/abpbase';
	import QuestionTpl from '@/store/entities/questiontpl'
	import QuestionTplDet from '@/store/entities/questiontpldet'
	import QuestionTplDetValue from '@/store/entities/questiontpldetvalue'
	import ToggleSwitch from '@/components/ToggleSwitch.vue'
	@Component({
		components: {
			ToggleSwitch
		}
	})
	export default class Questionnaire extends AbpBase {
		qid:number=0;
		updateQuestion: QuestionTpl = new QuestionTpl();
		imagebox: boolean = false;
		visible: boolean = false;
		inputtext:string="";
		isAppHomePrompt:boolean=false;
		detList: Array < QuestionTplDet >= new Array < QuestionTplDet > ();
		isVerifyPrompt:boolean=false;
		isShowError:boolean=false;
		disabled :boolean=false;
		imgBox:boolean=false;
		picindex:number=0;	
		picvalueindex:number=0;
		questionDetValue:QuestionTplDetValue=new QuestionTplDetValue();		
		previewImage:string="";
		visibleImage:boolean=false;
		isEdit:boolean=true;
		
		moveTop(index){
			var that=this;
			var det=that.detList[index];
			if(det.sort==1){
				that.$Message.warning(this.L('已经在第一个了'));
			}
			else{										
				//3到1 先把3换到2 再把2换成1
				for(var i=that.detList.length-1;i>=0;i--){					
					if(that.detList[i].sort<det.sort){
						var sort=that.detList[i].sort;//2
						var next=that.detList[i+1];						
						that.detList[i+1]=that.detList[i];
						that.detList[i+1].sort=next.sort;
						that.detList[i]=next;
						that.detList[i].sort=sort;
						console.log(that.detList);
						this.$forceUpdate();
					}					
				}				
				this.$forceUpdate();
			}
		}
		moveBottom(index){
			var that=this;
			var det=that.detList[index];
			if(det.sort==that.detList.length){
				that.$Message.warning(this.L('已经在最后一个了'));
			}
			else{
				//1到3 先把1换到2 再把2换成3
				for(var i=0;i<that.detList.length;i++){					
					if(that.detList[i].sort>det.sort){
						var sort=that.detList[i].sort;//2
						var next=that.detList[i-1];						
						that.detList[i-1]=that.detList[i];
						that.detList[i-1].sort=next.sort;
						that.detList[i]=next;
						that.detList[i].sort=sort;
						console.log(that.detList);
						this.$forceUpdate();
					}					
				}				
				this.$forceUpdate();
			}
		}
		movePre(index){
			var that=this;
			var det=that.detList[index];			
			if(det.sort==1){
				that.$Message.warning(this.L('已经在第一个了'));
			}
			else{
				var sort=det.sort;
				var preDet=that.detList[index-1];
				that.detList[index-1]=det;
				that.detList[index-1].sort=preDet.sort;
				that.detList[index]=preDet;
				that.detList[index].sort=sort;				
				this.$forceUpdate();
			}
		}
		moveNext(index){
			var that=this;
			var det=that.detList[index];
			if(det.sort==that.detList.length){
				that.$Message.warning(this.L('已经在最后一个了'));
			}
			else{
				var sort=det.sort;
				var preDet=that.detList[index+1];
				that.detList[index+1]=det;
				that.detList[index+1].sort=preDet.sort;
				that.detList[index]=preDet;
				that.detList[index].sort=sort;				
				this.$forceUpdate();
			}
		}
		moveTopValue(index,valueindex){
			var that=this;
			var detvalue=that.detList[index].questionTplDetValueList[valueindex];
			var detValueList=that.detList[index].questionTplDetValueList;
			if(detvalue.sort==1){
				that.$Message.warning(this.L('已经在第一个了'));
			}
			else{										
				//3到1 先把3换到2 再把2换成1
				for(var i=detValueList.length-1;i>=0;i--){					
					if(detValueList[i].sort<detvalue.sort){
						var sort=detValueList[i].sort;//2
						var next=detValueList[i+1];						
						detValueList[i+1]=detValueList[i];
						detValueList[i+1].sort=next.sort;
						detValueList[i]=next;
						detValueList[i].sort=sort;
						this.$forceUpdate();
					}					
				}	
				that.detList[index].questionTplDetValueList=detValueList;
				this.$forceUpdate();
			}
		}
		moveBottomValue(index,valueindex){
			var that=this;
			var detvalue=that.detList[index].questionTplDetValueList[valueindex];
			var detValueList=that.detList[index].questionTplDetValueList;
			if(detvalue.sort==detValueList.length){
				that.$Message.warning(this.L('已经在最后一个了'));
			}
			else{
				//1到3 先把1换到2 再把2换成3
				for(var i=0;i<detValueList.length;i++){					
					if(detValueList[i].sort>detvalue.sort){
						var sort=detValueList[i].sort;//2
						var next=detValueList[i-1];						
						detValueList[i-1]=detValueList[i];
						detValueList[i-1].sort=next.sort;
						detValueList[i]=next;
						detValueList[i].sort=sort;
						this.$forceUpdate();
					}					
				}	
				that.detList[index].questionTplDetValueList=detValueList;
				this.$forceUpdate();
			}
		}
		movePreValue(index,valueindex){
			var that=this;
			var detvalue=that.detList[index].questionTplDetValueList[valueindex];
			var detValueList=that.detList[index].questionTplDetValueList;			
			if(detvalue.sort==1){
				that.$Message.warning(this.L('已经在第一个了'));
			}
			else{
				var sort=detvalue.sort;
				var preDet=detValueList[valueindex-1];
				detValueList[valueindex-1]=detvalue;
				detValueList[valueindex-1].sort=preDet.sort;
				detValueList[valueindex]=preDet;
				detValueList[valueindex].sort=sort;	
				that.detList[index].questionTplDetValueList=detValueList;
				this.$forceUpdate();
			}
		}
		moveNextValue(index,valueindex){
			var that=this;			
			var detvalue=that.detList[index].questionTplDetValueList[valueindex];
			var detValueList=that.detList[index].questionTplDetValueList;
			if(detvalue.sort==detValueList.length){
				that.$Message.warning(this.L('已经在最后一个了'));
			}
			else{
				var sort=detvalue.sort;
				var preDet=detValueList[valueindex+1];
				detValueList[valueindex+1]=detvalue;
				detValueList[valueindex+1].sort=preDet.sort;
				detValueList[valueindex]=preDet;
				detValueList[valueindex].sort=sort;	
					
				that.detList[index].questionTplDetValueList=detValueList;
				this.$forceUpdate();
			}
		}
		
		addQuestionItem() {
			var that = this;
			var newItem = new QuestionTplDet();
			newItem.sort = that.detList.length + 1;
			newItem.name = "";
			newItem.questionValueType = 1;
			newItem.isMust = 0;
			newItem.answer = "";
			newItem.answerParse = "";
			newItem.status = "OP";
			newItem.questionTplDetValueList = new Array < QuestionTplDetValue > ();
			that.detList.push(newItem);
			that.$forceUpdate();
		}
		delQuestionItem(index) {
			var that = this;
			(that.detList as Array < Object > ).splice(index, 1);
			for (var i = 0; i < that.detList.length; i++) {
				that.detList[i].sort = (i + 1);
			}
			that.$forceUpdate();
		}
		addQuestionItemValue(index) {
			var that = this;
			var newItem = that.detList[index] as QuestionTplDet;
			var newItemValue = new QuestionTplDetValue();
			newItemValue.shortName = "";
			newItemValue.name = "";
			newItemValue.file = "";
			newItemValue.status = "OP";
			if (newItem.questionTplDetValueList != null) {
				newItemValue.sort = newItem.questionTplDetValueList.length + 1;
				if(newItemValue.sort==1){
					newItemValue.shortName = "A";
				}
				else if(newItemValue.sort==2){
					newItemValue.shortName = "B";
				}
				else if(newItemValue.sort==3){
					newItemValue.shortName = "C";
				}
				else if(newItemValue.sort==4){
					newItemValue.shortName = "D";
				}
				newItem.questionTplDetValueList.push(newItemValue);
			} else {
				newItemValue.sort = 1;
				newItemValue.shortName = "A";
				newItem.questionTplDetValueList = new Array < QuestionTplDetValue > ();
				newItem.questionTplDetValueList.push(newItemValue);
			}
			that.$forceUpdate();
		}
		delQuestionItemValue(index, valueindex) {
			var that = this;
			var newItem = that.detList[index];
			newItem.questionTplDetValueList.splice(valueindex, 1);
			for (var i = 0; i < newItem.questionTplDetValueList.length; i++) {
				newItem.questionTplDetValueList[i].sort = (i + 1);
				if((i + 1)==1){
					newItem.questionTplDetValueList[i].shortName = "A";
				}
				else if((i + 1)==2){
					newItem.questionTplDetValueList[i].shortName = "B";
				}
				else if((i + 1)==3){
					newItem.questionTplDetValueList[i].shortName = "C";
				}
				else if((i + 1)==4){
					newItem.questionTplDetValueList[i].shortName = "D";
				}
			}
			that.$forceUpdate();
		}
		
		saveFile(){
			var that=this;
			var newItem = that.detList[that.picindex];
			newItem.questionTplDetValueList[that.picvalueindex]=that.questionDetValue;
		}
		uploadItemValueFile(index,valueindex){
			var that = this;
			var newItem = that.detList[index];
			that.picindex=index;
			that.picvalueindex=valueindex;
			that.questionDetValue=newItem.questionTplDetValueList[valueindex];
			that.imgBox=true;			
		}
		previewItemValueFile(index,valueindex){
			var that = this;
			var newItem = that.detList[index];
			that.previewImage=newItem.questionTplDetValueList[valueindex].file;
			that.visibleImage=true;
		}
		delItemValueFile(index,valueindex){
			var that = this;
			var newItem = that.detList[index];
			newItem.questionTplDetValueList[valueindex].file="";
		}
		
		saveVerify() {
			var that = this;			
			if (that.isAppHomePrompt == true) {
				that.updateQuestion.isAppHomePrompt = true;
			} else if (that.isAppHomePrompt == false) {
				that.updateQuestion.isAppHomePrompt = false;
			}
			if (this.updateQuestion.name == '') {
				that.$Message.warning(this.L('名称不能为空'));
				this.$emit('input', false);
				return
			}
			if (this.updateQuestion.startTime == null || this.updateQuestion.endTime == null) {
				that.$Message.warning(this.L('请选择活动时间'));
				return
			}
			if (that.detList.length == 0) {
				that.$Message.warning(this.L('请添加明细项'));
				return;
			}
			for (var i = 0; i < that.detList.length; i++) {
				var each = that.detList[i];
				if (each.name == null || each.name.length == 0) {
					that.$Message.warning((this.L('请输入第项标题') as any).replace("{0}", each.sort));
					return
					break;
				}
				for (var j = 0; j < each.questionTplDetValueList.length; j++) {
					var eachValue = each.questionTplDetValueList[j];
					if (eachValue.name == null || eachValue.name.length == 0) {
						that.$Message.warning((this.L('请输入第项选择名称') as any).replace("{0}", each.sort).replace("{1}",eachValue.sort)  );
						return
						break;
					}
				}
			}
			
			this.updateQuestion.startTime = Util.changeDate(this.updateQuestion.startTime) as any;
			this.updateQuestion.endTime = Util.changeDate(this.updateQuestion.endTime) as any;
			(this.$refs.queryForm as any).validate(async (valid: boolean) => {
				if (valid) {
					console.log(that.updateQuestion);
					this.$Modal.confirm({
						title: this.L("Tips"),
						content: this.L("确定要保存？") ,
						okText: this.L('Yes'),
						cancelText: this.L('No'),
						onOk: async () => {
							that.disabled = true;
							this.$Message.loading({
								content: this.L("保存中") ,
								duration: 3
							});
							that.updateQuestion.questionType = 0;
							that.updateQuestion.questionTplDetList = that.detList;					
							that.$store.dispatch({
								type: 'app/createQuestionByApp',
								data: that.updateQuestion
							}).then((res) => {
								that.$Message.destroy();								
								that.updateQuestion.id=res;
								that.$Modal.success({
									title: this.L("Tips"),
									content: this.L("保存成功,请等待审核")
								});			
									
							}).catch(res => {
								that.disabled = false;
							});
						}
					});
					}
			})
			
		}
		handleMessage(onoff) {
			this.isAppHomePrompt = onoff;
			// (this.homePageModal as any).isAppHomePrompt = onoff;
		}	
		
		// handleDetValueSuccess
		handleView() {
			this.visible = true;
		}
		handleSuccess(res, file) {
		
		}
		handleRemove() {
			this.imagebox = false;
			this.updateQuestion.pic = '';
		}
		handleUpload(file) {
			const fileExt = file.name.split('.').pop().toLocaleLowerCase()
			if (fileExt === 'jpeg' || fileExt === 'jpg' || fileExt === 'png') {
				this.upload(file);
			} else {
				this.$Notice.warning({
					title: this.L("文件类型错误"),
					desc:  this.L('文件不是图片').replace("{0}", file.name )  
				})
		
			}
			return false;
		}
		handleDetValueSuccess(){
			
		}
		handleDetValueRemove() {
			this.questionDetValue.file="";
		}
		handleDetValueView() {
			this.previewImage=this.questionDetValue.file;
			this.visibleImage = true;
		}		
		handleDetValueUpload(file) {
			const fileExt = file.name.split('.').pop().toLocaleLowerCase()
			if (fileExt === 'jpeg' || fileExt === 'jpg' || fileExt === 'png') {
				this.uploadDetValue(file,fileExt);
			} else {
				this.$Notice.warning({
					title: this.L("文件类型错误"),
					desc: this.L('文件不是图片').replace("{0}", file.name )  
				})
		
			}
			return false;
		}
		async uploadDetValue(file,fileExt) {
			let that = this;
			var form = new FormData();
			form.append("file", file);
			var res = await this.$store.dispatch({
				type: 'app/uploadImage',
				data: form
			}).then((res) => {				
				that.questionDetValue.file = res;
				that.questionDetValue.suffix=fileExt;
			})
		
		}

		async upload(file) {
			let that = this;
			var form = new FormData();
			form.append("file", file);
			var res = await this.$store.dispatch({
				type: 'app/uploadImage',
				data: form
			}).then((res) => {
				that.updateQuestion.pic = res;
				that.imagebox = true;
			})

		}
		getQuestionTplById() {
			var that = this;
			this.$store.dispatch({
				type: 'app/getQuestionTplById',
				id: this.qid
			}).then((res) => {
				console.log(res);	
				that.updateQuestion = res;
				if(res.status=="OP" && res.isJoin){
					that.isEdit=false;
				}
				that.detList = res.questionTplDetList as Array < QuestionTplDet > ;
				
				for (var i = 0; i < that.detList.length; i++) {
					that.detList[i].isMust = that.detList[i].isMust ? 1 : 0;
				}
				
			})
		}
		


		async created() {				
			console.log(Util.abp.session.userId);
			if (!Util.abp.session.userId) {				
				var domain = this.$route.query.domain as any;
				if (domain != undefined && domain != null && domain != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSDOMAIN",
							"ProviderAccessCode": domain,
							ProviderKey: "",
							Property: ""
						},
					})
					location.reload();
				}
				var userId = this.$route.query.userid as any;
				if (userId != undefined && userId != null && userId != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSID",
							"ProviderAccessCode": userId,
							ProviderKey: userId,
							Property: ""
						},
					})
					location.reload();
				}
			}
			if (this.$route.query.qid && (this.$route.query.qid as any) > 0) {
				this.qid = this.$route.query.qid as any;
				
				this.getQuestionTplById();				
			}
			else{
				this.updateQuestion = new QuestionTpl();
				this.updateQuestion.point = 0;
				this.updateQuestion.lotteryCount = 0;
				this.updateQuestion.voteCount = 0;
				this.updateQuestion.voteDayCount = 0;
				this.updateQuestion.name = "";
				this.updateQuestion.id = 0;
				this.isAppHomePrompt = (this.updateQuestion.isAppHomePrompt == null || !this.updateQuestion.isAppHomePrompt) ? false :
					true;		
			}
			
		}
		rules = {
			name: [{
				required: true,
				message: this.L('名称不能为空'),
				trigger: 'blur'
			}],
			desc: [{
				required: true,
				message: this.L('描述不能为空'),
				trigger: 'blur'
			}],
			startTime: [{
				required: true,
				message: this.L('开始时间不能为空'),

			}],
			endTime: [{
				required: true,
				message: this.L('结束时间不能为空'),

			}],
		}
	}
